import React from "react";

const SuccessIcon = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="83"
        height="83"
        viewBox="0 0 83 83"
        fill="none">
        <circle cx="41.5" cy="41.5" r="26" stroke="#10B981" strokeWidth="4" />
        <path
          d="M34.5 42L39.5 47L48.5 36"
          stroke="#10B981"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export default SuccessIcon;